"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Subtitle = exports.LabelFlex = exports.Label = void 0;

var tslib_1 = require("tslib");

var ui_blocks_1 = require("@hopin-team/ui-blocks");

var ui_flex_1 = require("@hopin-team/ui-flex");

var ui_text_1 = require("@hopin-team/ui-text");

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

var base = ui_blocks_1.INTERACTIVE.base;
exports.Label = (0, styled_components_1.default)(ui_text_1.Text).attrs(function () {
  return {
    element: 'label'
  };
})(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  user-select: none;\n  padding-left: 1rem;\n  ", "\n"], ["\n  user-select: none;\n  padding-left: 1rem;\n  ", "\n"])), base);
exports.LabelFlex = (0, styled_components_1.default)(ui_flex_1.Flex).attrs({
  pl: 1.5
})(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject([""], [""])));
exports.Subtitle = (0, styled_components_1.default)(ui_text_1.Text)(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  line-height: 1.25rem;\n"], ["\n  line-height: 1.25rem;\n"])));
var templateObject_1, templateObject_2, templateObject_3;